import axios from "axios";
import { API_BASE_URL } from "../config";
import { getAuthHeaders } from "./developerApi";

export const getSupplierOrgRoutingRules = async () => {
    const response = await axios.get(
        `${API_BASE_URL}/business/supplier-org-routing`,
        getAuthHeaders(),
    );
    return response.data || [];
};

export const createSupplierOrgRoutingRule = async (payload) => {
    const response = await axios.post(
        `${API_BASE_URL}/business/supplier-org-routing`,
        payload,
        getAuthHeaders(),
    );
    return response.data;
};

export const updateSupplierOrgRoutingRule = async (routingId, payload) => {
    const response = await axios.put(
        `${API_BASE_URL}/business/supplier-org-routing/${routingId}`,
        payload,
        getAuthHeaders(),
    );
    return response.data;
};

export const deleteSupplierOrgRoutingRule = async (routingId) => {
    const response = await axios.delete(
        `${API_BASE_URL}/business/supplier-org-routing/${routingId}`,
        getAuthHeaders(),
    );
    return response.data;
};

export const getSupplierOrgRoutingOptions = async () => {
    const [organizations, suppliers, stores, enterprises] = await Promise.all([
        axios.get(`${API_BASE_URL}/business-organizations`, getAuthHeaders()),
        axios.get(`${API_BASE_URL}/dropship/enterprises/`, getAuthHeaders()),
        axios.get(`${API_BASE_URL}/business-stores`, getAuthHeaders()),
        axios.get(`${API_BASE_URL}/business-stores/meta/business-enterprises`, getAuthHeaders()),
    ]);
    return {
        organizations: organizations.data || [],
        suppliers: suppliers.data || [],
        stores: stores.data || [],
        enterprises: enterprises.data || [],
    };
};
